import React, { Suspense } from 'react';
import { useTypedSelector } from '@hooks';
import { useDebounced } from '@helpers/useDebounced';

const AddToExistingLinkModal = React.lazy(
  () => import('./AddToExistingLinkModal')
);

export default function AddToExistingLinkModalContainer() {
  const modalState = useTypedSelector(
    ({ modal }) => modal.addToExistingLinkModal
  );
  const visibleDebounced = useDebounced(modalState?.visible, 300, false);
  const visible = modalState?.visible || visibleDebounced;
  if (!modalState || !visible) return null;
  return (
    <Suspense fallback={null}>
      <AddToExistingLinkModal {...modalState} />
    </Suspense>
  );
}
